import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col items-start justify-start mb-6" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "input-label mb-3" }, [
  /*#__PURE__*/_createTextVNode(" NIP pracodawcy "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-error" }, "*")
], -1)
const _hoisted_3 = { class: "flex flex-col md:flex-row items-start justify-start w-full" }
const _hoisted_4 = { class: "w-full gap-3 flex flex-col items-start justify-start" }
const _hoisted_5 = { class: "w-full" }
const _hoisted_6 = { class: "absolute top-[28px] lg:top-[36px] right-0 -translate-x-1/2 -translate-y-1/2" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<svg width=\"18px\" height=\"21px\" viewBox=\"0 0 18 21\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"3-3-Produkt:-Zamówienie\" transform=\"translate(-1459, -876)\" fill=\"#F56531\" fill-rule=\"nonzero\"><g id=\"ui/delete\" transform=\"translate(1459, 876)\"><path d=\"M8.9993,0 C10.8234,-0.0001 12.4167,1.2334 12.8735,2.9994 L17,2.9999 C17.5523,2.9999 18,3.4476 18,3.9999 C18,4.5522 17.5523,4.9999 17,4.9999 L11,4.9999 L11,3.9999 C11.0017,3.2844 10.6210,2.6225 10.0016,2.2642 C9.3823,1.9059 8.6187,1.9059 7.9993,2.2640 C7.3799,2.6221 6.9990,3.2839 7.0005,3.9994 L7.001,4.9999 L3,4.9999 L3,18 C3,18.5519 3.4480,18.9992 4,18.9999 L14,18.9999 C14.5520,18.9992 15,18.5519 15,18 L15,8 C15,7.4476 15.4477,7 16,7 C16.5523,7 17,7.4476 17,8 L17,18 C17,19.6560 15.6561,20.9981 14,20.9999 L4,20.9999 C2.3439,20.9981 1.0018,19.6560 1,18 L1,4.9999 C0.4477,4.9999 0,4.5522 0,3.9999 C0,3.4476 0.4477,2.9999 1,2.9999 L5.1255,2.9999 C5.5820,1.2339 7.1752,0 8.9993,0 Z M11.7006,9.2993 C12.0886,9.6873 12.0915,10.3154 11.707,10.7069 L10.414,11.999 L11.707,13.2929 C11.9929,13.5789 12.0784,14.0090 11.9237,14.3826 C11.7689,14.7562 11.4044,14.9998 11,14.9999 C10.7347,15.0002 10.4803,14.8948 10.293,14.7069 L9,13.413 L7.707,14.7069 C7.5197,14.8948 7.2653,15.0002 7,14.9999 C6.5956,14.9998 6.2311,14.7562 6.0763,14.3826 C5.9216,14.0090 6.0071,13.5789 6.293,13.2929 L7.586,11.999 L6.293,10.7069 C5.9085,10.3154 5.9114,9.6873 6.2994,9.2993 C6.6874,8.9113 7.3155,8.9085 7.707,9.2929 L9,10.585 L10.293,9.2929 C10.6845,8.9085 11.3126,8.9113 11.7006,9.2993 Z\"></path></g></g></g></svg>", 1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "ml-0 md:ml-4 mt-3 flex items-center justify-center" }
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-[17px] text-textBlack leading-[20px] ml-5" }, " Dodaj kolejny NIP (opcjonalne) ", -1)

import { ErrorMessage, Field, useFieldArray } from 'vee-validate';


export default {
  __name: 'NIPField',
  props: {
  theme: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const { fields, remove, push } = useFieldArray('nip');

// Zapewnij, że zawsze przynajmniej jedno pole jest dostępne
if (fields.value.length === 0) {
  push({ value: '' });
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fields), (field, idx) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "w-full flex flex-col items-start md:flex-row md:items-center md:justify-start relative",
            key: field.key
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_unref(Field), {
                name: `nip[${idx}].value`,
                rules: "required"
              }, {
                default: _withCtx(({ errors, field }) => [
                  _createElementVNode("input", _mergeProps(field, {
                    type: "text",
                    class: ["form-input !mt-0", {
                  'border-[1px] border-error border-solid': errors.length,
                  'border-none': !errors.length,
                }]
                  }), null, 16)
                ]),
                _: 2
              }, 1032, ["name"]),
              _createVNode(_unref(ErrorMessage), {
                name: `nip[${idx}].value`,
                class: "error-message block text-[15px]"
              }, null, 8, ["name"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              (_unref(fields).length > 1)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: $event => (_unref(remove)(idx)),
                    type: "button",
                    class: "Button Button--no-style flex items-center justify-center w-[48px] h-[48px] flex-shrink-0 rounded-full bg-accentOrange/10"
                  }, _hoisted_9, 8, _hoisted_7))
                : _createCommentVNode("", true)
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("label", {
          class: "flex flex-shrink-0 items-center justify-center w-[48px] h-[48px] rounded-full bg-primary/10",
          onClick: _cache[0] || (_cache[0] = $event => (_unref(push)({ value: '' })))
        }, [
          _createElementVNode("img", {
            src: _ctx.$config?.icons?.plus || '',
            alt: "plus icon",
            class: "w-6 h-6"
          }, null, 8, _hoisted_11)
        ]),
        _hoisted_12
      ])
    ])
  ]))
}
}

}